// extracted by mini-css-extract-plugin
export default {"title":"search_product_family__title--PWI5"};